module.exports = __webpack_public_path__ + "img/arrow_left.0e52bfc9.svg";